import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfigureProductGroup } from './config_product_group/config_product_group.component';
import { ConfigureProduct } from './config_product/config_product.component';
import { ConfigureSubProduct } from './config_sub_product/config_sub_product.component';
import { AuthGuard, SharedModule } from '../../shared';
import { ConfigProductService } from './config_product.service';

const configureProductGroupRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'setting/config/product-group',
    component: ConfigureProductGroup,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  },
   {
    path: 'setting/config/product',
    component: ConfigureProduct,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  },
   {
    path: 'setting/config/sub-product',
    component: ConfigureSubProduct,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }
]);

@NgModule({
  imports: [  
    SharedModule,
    configureProductGroupRouting,
    NgbModule
  ],
  declarations: [
    ConfigureProductGroup,
    ConfigureProduct,
    ConfigureSubProduct
  ],
  providers: [
 ConfigProductService
  ],
})
export class ConfigureProductModule {}


// WEBPACK FOOTER //
// ./src/app/system_setting/configure_product/config_product.module.ts